import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import AuthModal from "./components/AuthModal";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Services from "./pages/Services";
import AboutUs from "./pages/AboutUs";
import HowItWorks from "./pages/HowItWorks";
import FAQ from "./pages/FAQ";
import ServiceBooking from "./pages/ServiceBooking";
import Checkout from "./pages/Checkout";
import SearchResults from "./pages/SearchResults";
import Account from "./pages/Account";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import BlogsList from "./pages/BlogsList";
import BlogDetail from "./pages/BlogDetail";
import CustomBooking from "./pages/CustomBooking";
import Support from "./pages/Support";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/services/:id/booking" element={<ServiceBooking />} />
          <Route path="/services/:id/checkout" element={<Checkout />} />
          <Route path="/search" element={<SearchResults />} />
          <Route path="/account" element={<Account />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsConditions />} />
          <Route path="/blog" element={<BlogsList />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/custom-booking" element={<CustomBooking />} />
          <Route path="/support" element={<Support />} />
        </Routes>
        <Footer />
        <AuthModal />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
